import { render } from "./CookiesComponent.vue?vue&type=template&id=1600491f"
import script from "./CookiesComponent.vue?vue&type=script&lang=js"
export * from "./CookiesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Cookies/CookiesComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1600491f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1600491f', __exports__)) {
    api.reload('1600491f', __exports__)
  }
  
  module.hot.accept("./CookiesComponent.vue?vue&type=template&id=1600491f", () => {
    api.rerender('1600491f', render)
  })

}


export default __exports__